import { createContext } from 'react'

interface HotkeysContextType {
  enableScopes: (scopes: string[]) => void
  disableScopes: (scopes: string[]) => void
  disableAllScopes: () => void
  activeScopes: string[]
  scopeIsActive: (scope: string) => boolean
  anyScopesActive: (scopes: string[]) => boolean
}

const noop: () => void = () => undefined

export const HotkeysContext = createContext<HotkeysContextType>({
  enableScopes: noop,
  disableScopes: noop,
  disableAllScopes: noop,
  activeScopes: [],
  scopeIsActive: () => true,
  anyScopesActive: () => true,
})
